import Mediator from './Mediator';

class Classroom extends Mediator {
  constructor(data) {
    super(data);

    if (data instanceof Mediator) {
      return this; 
    }
    
    this.setVersion('v1', [
      'school_classroom_id', 'name', 'seating_capacity'
    ]);

    this.__schema = {
      id: {
        alias: ['id', 'school_classroom_id'],
      },
      name: {
        alias: ['name'],
      }, 
      seatingCapacity: {
        alias: ['seatingCapacity', 'seating_capacity'],
      },
    }

    return this.create();
  }


}

export default Classroom;




// WEBPACK FOOTER //
// ./src/mediators/Classroom.js